import { OptionCard } from "@/components/WizardShell";
import { useTranslation } from "react-i18next";

export default function Step1Profile({ ref_data, value, onChange }) {
  const { t } = useTranslation();
  const set = (patch) => onChange(patch);
  return (
    <div className="space-y-6 py-8" data-testid="step-1">
      <p className="text-slate-600 leading-relaxed max-w-3xl text-[15px]">
        {t("wizard.s1_intro")}
      </p>
      <div>
        <div className="label-caps">{t("wizard.s1_objective_label")}</div>
        <div className="mt-4 grid sm:grid-cols-2 gap-3">
          {ref_data.objectives.map((o) => (
            <OptionCard key={o.id} selected={value.objective === o.id} onClick={() => set({ objective: o.id })} testId={`profile-objective-${o.id}`}>
              {o.label}
            </OptionCard>
          ))}
        </div>
      </div>
    </div>
  );
}

export const step1Valid = (v) => !!v.objective;
